import React, { memo, useContext, useState } from "react";
import ActivityLayout from "app/components/Layouts/ActivityPageLayout";
import { useBookingLogsModel } from "./indexModel";
import BookingLogList from "app/components/BookingLogList";
import { RoleType, UserContext } from "app/contexts/UserContext";
import LogsFilters from "app/components/LogsFilters";
import { DateTime } from "luxon";

const ActivityBookingLogs = () => {
  const userRole = useContext(UserContext);
  const isCoach = userRole.role === RoleType.COACH;
  const [logsQuery, setLogsQuery] = useState<{
    perPage: number;
    from?: string;
    to?: string;
    user_ids?: string[];
    log_types?: string[];
  }>({
    perPage: 50,
    from: DateTime.now().minus({ days: 30 }).toISODate(),
    to: DateTime.now().toISODate(),
  });

  const {
    groupedBookingLogs,
    loading,
    nullData,
    bookingLogsContainer,
  } = useBookingLogsModel(logsQuery);

  return (
    <ActivityLayout>
      <LogsFilters setLogsQuery={setLogsQuery} />
      <BookingLogList
        data={groupedBookingLogs}
        nullData={nullData}
        loading={loading}
        bookingLogsContainer={bookingLogsContainer}
        isCoach={isCoach}
      />
    </ActivityLayout>
  );
};

export default memo(ActivityBookingLogs);
